import { Curtain } from '../../../components/curtain/Curtain';
import { PopupType } from '../../../components/popup/types';
import { CrossOriginCommunication } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface SessionMessage extends GameCommunicationMessageType {
  session?: string;
}

export class CoreSessionGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Session;
  public delay = 0;
  public seq = -1;

  public process(message: SessionMessage): void {
    if (message.session?.toLowerCase() === 'offline') {
      CrossOriginCommunication.dispatch(OutgoingMessage.ErrorMessage, {
        errorCode: '8075',
        errorMessage: 'SESSION_EXPIRED_ERROR',
      });
      Curtain.resurrect();
      this.store.dispatch(popupActions.overwritePopup(PopupType.SessionExpired));
      this.store.dispatch(gameStateActions.setGameAbandoned(true));
    }
  }
}
